export default __webpack_public_path__ + "static/media/Bg1.b86126af.jpg";